<script setup lang="ts">
import type { ILawyerCardInfo } from '@/entities/lawyer/model/types/lawyer';

const isMobile: boolean = useIsMobile();
const lawyerInfo = inject<ILawyerCardInfo>('lawyerInfo');

const isHigh: ComputedRef<boolean> = computed(() => lawyerInfo?.price_level === 'high');
const isMiddle: ComputedRef<boolean> = computed(() => lawyerInfo?.price_level === 'mid');
const isLow: ComputedRef<boolean> = computed(() => lawyerInfo?.price_level === 'low');
</script>

<template>
  <div :class="['lawyer-card-cost', { _mobile: isMobile }]">
    <div
      :class="[
        'lawyer-card-cost__value',
        { _high: isHigh },
        { _middle: isMiddle },
        { _low: isLow },
      ]"
    >
      <span v-for="i in 3" :key="i" class="lawyer-card-cost__level"> &#8381; </span>
    </div>
  </div>
</template>

<style lang="less">
.lawyer-card-cost {
  display: flex;
  align-items: center;

  &__value {
    display: inline-flex;
    font-size: @size-x3;
    line-height: @size-x4;
    font-weight: 600;
  }

  &__value._high &__level {
    font-weight: 600;
    color: @color-elephant;
  }

  &__value._middle &__level:last-child {
    font-weight: 500;
    color: @color-silver-chalice;
  }

  &__value._low &__level:nth-child(n + 2) {
    font-weight: 500;
    color: @color-silver-chalice;
  }
}
</style>
